<template lang="pug">
  BTr
    BTd {{ item.id }}
    BTd(v-for="column in table" :key="column.code")
      template(v-if="column.type === 'integer'") {{ +item[column.code] }}
      template(v-if="column.type === 'string'") {{ item[column.code] }}
      template(v-if="column.type === 'date'") {{ item[column.code] | date }}
      template(v-if="column.type === 'datetime'") {{ item[column.code] | datetime }}
      template(v-if="column.type === 'boolean'")
        template(v-if="item[column.code]")
          i.fas.fa-check
      template(v-if="column.type === 'function'") {{ column.get(item[column.code]) }}
      template(v-if="column.type === 'image'")
        BImg(
          :width="column.width"
          :height="column.height"
          :src="item[column.code]"
          v-if="item[column.code]"
        )
      template(v-if="column.type === 'iframe'")
        .iframe(v-html="item[column.code]" :style="{ width: column.width + 'px' }")
      template(v-if="column.type === 'locales'")
        img.mr-2(v-for="locale in item[column.code]" :src=`require('@/assets/img/flags/' + locale + '.png')` alt="")
    BTd.text-right.text-nowrap
      RouterLink.btn.btn-default.btn-sm.btn-icon.mr-2(
        v-if="routes.edit"
        :to="{ name: routes.edit, params: { [routeKey]: item.id } }"
      )
        i.fa.fa-edit
      BButton.btn-sm.btn-icon.mr-2(
        :class="{ 'btn-danger': counter === 1, 'btn-default': counter === 0 }"
        @click="onClick(item.id)"
      )
        i.fa.fa-times
</template>

<script>
export default {
  props: {
    routeKey: { type: String, required: true },
    routes: { type: Object, required: true },
    table: { type: Array, required: true },
    item: { type: Object, required: true },
    onDelete: { type: Function, required: true }
  },
  data: () => ({
    counter: 0
  }),
  methods: {
    onClick (id) {
      this.counter++

      if (this.counter === 1) {
        this.timer = setTimeout(() => { this.counter = 0 }, 600)
        return
      }

      clearTimeout(this.timer)
      this.counter = 0
      this.onDelete(id)
    }
  }
}
</script>

<style lang="sass">
  .iframe iframe
    width: 100%
    height: auto
</style>
